"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
export function QueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 60000,
          gcTime: 300000,
          refetchOnWindowFocus: false,
          retry: 1
        },
        mutations: {
          retry: 1
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ReactQueryDevtools initialIsOpen={false} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <QueryClientProvider client={queryClient}>{children}{t2}</QueryClientProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}